import React, { useState } from 'react';
import { Select } from '../../../../atoms/Inputs/Select';
import { ButtonWithText } from '../../../../atoms/Buttons/ButtonWithText';
import { IconButton } from '../../../../atoms/Buttons/IconButton';
import useStyle from './productCardFooter.style';
import { classNames } from 'helpers/style/classNames';
import { ProductOnPanier } from '../../../../../types/product/product';
import { ID } from '../../../../../types/typeDef';
import { useSelector } from 'react-redux';
import { getChallengeStatus } from '../../../../../store/selectors/user/user.selectors';

export interface ProductCardMosaicFooterProps {
  onClick: () => void;
  onAddToCart: () => {
    product: ProductOnPanier;
    quantite: number;
    totalLine?: number;
    id?: ID;
  };
  setProductQuantity: (n: number) => void;
  isOut: boolean;
}

const ProductCardFooter = ({
  onClick,
  onAddToCart,
  setProductQuantity,
  isOut
}: ProductCardMosaicFooterProps) => {
  const classes = useStyle();
  const { status } = useSelector(getChallengeStatus);
  const [value, setValue] = useState(1);
  const handleClick = () => {
    onAddToCart();
    setValue(1);
  };
  const handleChange = (n: number) => {
    setProductQuantity(n);
    setValue(n);
  };

  return (
    <div
      className={classNames([classes.root], {
        condition: isOut,
        classe: classes.empty
      })}
    >
      {!isOut ? (
        <>
          <div className={classes.actionContainer}>
            <Select value={value} onChange={handleChange} maxValue={99} />
            <IconButton
              onClick={onClick}
              icon="MoreAbout"
              variant="backless"
              size="normal"
            />
          </div>
          <div className={classes.buttonContainer}>
            <ButtonWithText
              content={'Ajouter au panier'}
              onClick={handleClick}
              disabled={status !== 'available'}
            />
          </div>
        </>
      ) : (
        <p>Produit épuisé</p>
      )}
    </div>
  );
};

export default ProductCardFooter;
